import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <InfoSection title="Um 1819">
            <p style={{ textAlign: "justify" }}>
                1819 er uppl&yacute;singa og &thorn;j&oacute;nustufyrirt&aelig;ki sem leitast
                vi&eth; a&eth; a&eth;sto&eth;a einstaklinga sem og fyrirt&aelig;ki &iacute;
                uppl&yacute;singagj&ouml;f og aukins s&yacute;nileika.&nbsp;
            </p>
            <p>
                1819 heldur uppi heimas&iacute;&eth;u sem l&iacute;kja m&aacute; vi&eth;
                rafr&aelig;na s&iacute;maskra, en &iacute; raun er heimas&iacute;&eth;an
                leitarv&eacute;l &thorn;ar sem h&aelig;gt er a&eth; finna &yacute;msar
                uppl&yacute;singar um fyrirt&aelig;ki, opnunart&iacute;ma, s&iacute;man&uacute;mer
                og heimilisf&ouml;ng.
            </p>
            <p>
                Uppl&yacute;singan&uacute;mer 1819 hefur &thorn;a&eth; markmi&eth; a&eth; veita
                hra&eth;a, h&aacute;g&aelig;&eth;a &thorn;j&oacute;nustu vi&eth;
                uppl&yacute;singagj&ouml;f &aacute;samt &thorn;v&iacute; a&eth; starfsf&oacute;lk
                okkar s&eacute;rh&aelig;fir sig &iacute; s&iacute;msv&ouml;run og ritarast&ouml;rfum
                fyrir allar st&aelig;r&eth;ir fyrirt&aelig;kja.
            </p>
            <p>
                Markmi&eth; okkar allra hj&aacute; 1819 er a&eth; au&eth;velda a&eth;gengi a&eth;
                uppl&yacute;singum sem lei&eth;a til einfaldari samskipta einstaklinga og
                fyrirt&aelig;kja &aacute; &Iacute;slandi.
            </p>
            <p>
                Okkar h&aelig;fileikar&iacute;ka starfsf&oacute;lk gerir &thorn;itt daglega
                l&iacute;f au&eth;veldara.
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
                Vi&eth; vinnum &iacute; sameiningu a&eth; gildum 1819
            </p>
            <h3 style={{ textAlign: "center" }}>Lipur&eth; - G&aelig;&eth;i - Vir&eth;ing</h3>
            <p style={{ textAlign: "center" }}>&nbsp;</p>
        </InfoSection>
    );
}
export default ServiceNumber;
